import { IconOptions } from "leaflet";

export const DESTINATION_PIN_SVG = `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 475.06 512" fill="#29275B"><path d="M225.88,50.88c24.62-2.3,49.85.51,73.04,9.27,31.75,12.06,60.33,33.14,79.83,61.1,18.27,25.5,29.18,56.4,29.88,87.84,1,25.1-5.18,50.08-15.66,72.78-10.94,23.13-26.36,43.78-42.81,63.25-26.74,31.8-55.76,61.59-85.19,90.89-7.26,6.94-14.19,14.24-21.76,20.84-16.22-15.14-31.53-31.21-47.13-46.97-21.32-22.08-42.47-44.35-62.2-67.87-12.81-15.78-25.34-31.93-35.06-49.84-15.34-27.94-22.91-60.43-19.62-92.27,2.78-31.96,16.19-62.51,36.18-87.44,27.22-33.53,67.45-56.61,110.5-61.58ZM230.49,133.76c-19.69,3.05-38.08,13.55-50.88,28.8-12.29,14.48-19.21,33.43-19.04,52.43-.21,16.37,5.1,32.68,14.81,45.85,11.88,17.21,30.82,28.89,51.13,33.27,17.6,3.53,36.36,1.55,52.64-6.14,18.61-8.54,34.01-24.11,41.81-43.11,7.05-16.25,7.54-34.91,2.89-51.88-6.47-22.68-23.23-42.19-44.59-52.13-15.06-7.14-32.3-9.62-48.77-7.09Z"\/><\/svg>`

export const MAP_ASSETS = {
    marker: {
        start: {
            iconUrl: "https://www.google.com/maps/vt/icon/name=assets/icons/directions/directions_measle-2-medium.png&scale=1",
            iconSize: [16, 16],
            popupAnchor: [1, -16],
        } satisfies IconOptions,
        end: {
            iconUrl: "https://www.google.com/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v4_outline-2-medium.png,assets/icons/spotlight/spotlight_pin_v4-2-medium.png,assets/icons/spotlight/spotlight_pin_v4_dot-2-medium.png&highlight=c5221f,ea4335,b31412?scale=1",
            iconSize: [28, 39],
            iconAnchor: [14, 39],
            shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
            shadowSize: [41, 41],
            popupAnchor: [1, -36],
        } satisfies IconOptions,
        stop: {
            iconUrl: "https://www.google.com/maps/vt/icon/name=assets/icons/spotlight/spotlight_pin_v4_outline-2-medium.png,assets/icons/spotlight/spotlight_pin_v4-2-medium.png,assets/icons/spotlight/spotlight_pin_v4_dot-2-medium.png&highlight=c5221f,ea4335,b31412?scale=1",
            iconSize: [28, 39],
            iconAnchor: [14, 39],
            shadowUrl: "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
            shadowSize: [41, 41],
            popupAnchor: [1, -36],
        } satisfies IconOptions,
    },
    loading: "https://maps.gstatic.com/tactile/pane/spinner_color.gif",
} as const
